const usersTableConf = [
  {
    isSortable: true,
    field: 'firstName',
    title: 'User Name'
  },
  {
    isSortable: true,
    field: 'status',
    title: 'Status'
  },
  {
    isSortable: true,
    field: 'role',
    title: 'Role'
  },
  {
    isSortable: true,
    field: '_last_login',
    title: 'Last Login'
  },
  {
    isSortable: false,
    field: 'actions',
    title: ''
  }
];

export { usersTableConf };
